import React from "react";
import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ArrowRight, Play } from "lucide-react";

export const HeroSection = ({ onContactClick }) => {
  return (
    <section
      data-testid="hero-section"
      className="relative min-h-[88vh] overflow-hidden flex items-center"
    >
      {/* Background Image */}
      <div className="absolute inset-0">
        <div className="hero-bg absolute inset-0"></div>
        <img
          src="https://images.unsplash.com/photo-1758448755952-42b404bc6f39?w=1920&q=80"
          alt="Luxury Interior Design"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="noise-overlay"></div>
      </div>

      {/* Content */}
      <div className="container relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="max-w-3xl"
        >
          <p className="uppercase tracking-[0.35em] text-[11px] text-white/70 mb-6">
            Bespoke Luxury Interiors
          </p>
          <h1 className="font-display text-white text-4xl sm:text-5xl lg:text-7xl leading-[1.05] font-semibold mb-6">
            Timeless Opulence,
            <br />
            Tailored to Your Home
          </h1>
          <p className="text-white/80 text-lg max-w-2xl mb-10 leading-relaxed">
            End-to-end interiors with masterful craftsmanship across Bangalore,
            Hyderabad, and Chennai. 5091+ happy homes designed with passion.
          </p>
          <div className="flex flex-wrap gap-4">
            <Button
              variant="gold"
              size="lg"
              onClick={onContactClick}
              data-testid="hero-primary-cta-button"
              className="text-base"
            >
              Schedule Consultation
              <ArrowRight className="w-5 h-5" />
            </Button>
            <Button
              variant="glass"
              size="lg"
              onClick={() =>
                document.getElementById("portfolio")?.scrollIntoView({ behavior: "smooth" })
              }
              data-testid="hero-secondary-cta-button"
              className="text-white text-base"
            >
              <Play className="w-5 h-5" />
              View Portfolio
            </Button>
          </div>

          {/* Stats */}
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            className="flex flex-wrap gap-8 mt-16"
          >
            <div>
              <div className="text-[hsl(var(--brand-gold))] text-3xl font-display font-semibold">
                9+
              </div>
              <div className="text-white/60 text-sm uppercase tracking-wider">
                Years Experience
              </div>
            </div>
            <div>
              <div className="text-[hsl(var(--brand-gold))] text-3xl font-display font-semibold">
                5091+
              </div>
              <div className="text-white/60 text-sm uppercase tracking-wider">
                Happy Homes
              </div>
            </div>
            <div>
              <div className="text-[hsl(var(--brand-gold))] text-3xl font-display font-semibold">
                45-90
              </div>
              <div className="text-white/60 text-sm uppercase tracking-wider">
                Working Days
              </div>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default HeroSection;
